// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"74998d4a","1308":"b3c86ace","5096":"3743c3c0","8675":"0c172022"}[chunkId] + ".chunk.js";
};